import { render, staticRenderFns } from "./KimIcon.vue?vue&type=template&id=e79d6780"
import script from "./KimIcon.vue?vue&type=script&lang=js"
export * from "./KimIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports